<template>
    <div>
        <p class="title is-3 is-spaced">Global settings</p>

        <!-- General -->
        <p class="title is-4 is-spaced">General</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Pin length</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.pinLength" class="input  oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <!-- Short links -->
        <p class="title is-4 is-spaced">Short links</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Short links host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.shortLinksHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Short links api host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.shortLinksApiHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Short links api key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.shortLinksApiKey" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- FLG -->
        <p class="title is-4 is-spaced">FLG</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sys id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.flgSettings.sysId"
                               class="input oc-input"
                               type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Security key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.flgSettings.securityKey"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.flgSettings.widgetUrl"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Demo widget url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.flgSettings.demoWidgetUrl"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- BK -->
        <p class="title is-4 is-spaced">BK</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.bkSettings.apiHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.bkSettings.apiKey" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.bkSettings.widgetHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- COVID -->
        <p class="title is-4 is-spaced">COVID</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.covidSettings.apiHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Client API key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.covidSettings.clientApiKey"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Server API key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.covidSettings.serverApiKey"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- Bonus -->
        <p class="title is-4 is-spaced">Bonus</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Cashback bonus max percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.bonusSettings.cashbackBonusMaxPercent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Deposit bonus max percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.bonusSettings.depositBonusMaxPercent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Welcome bonus max percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.bonusSettings.welcomeBonusMaxPercent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Registration bonus max value</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <table class="table is-size-7">
                            <tr>
                                <th>Currency</th>
                                <th>Amount</th>
                            </tr>
                            <tr v-for="bon in settings.bonusSettings.registrationBonusMaxValue" :key="bon.currency">
                                <th>{{bon.currency}}</th>
                                <td>
                                    <currency-input :value="bon.amount"
                                                    :currency="bon.currency"
                                                    :set="(val) => bon.amount = val"
                                                    class="input is-small oc-input" />
                                </td>
                            </tr>
                        </table>
                    </p>
                </div>
            </div>
        </div>

        <!-- Jackpot -->
        <p class="title is-4 is-spaced">Jackpot</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Max charge percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.jackpotSettings.maxChargePercent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Chance jackpot played in round</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.jackpotSettings.chanceJackpotPlayedInRound" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Jackpot max play attempts</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.jackpotSettings.jackpotMaxPlayAttempts" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <!-- MBK -->
        <p class="title is-4 is-spaced">MBK</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.mbkSettings.apiHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.mbkSettings.apiKey" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- Withdrawal -->
        <p class="title is-4 is-spaced">Withdrawal</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Max retention percent</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.withdrawalSettings.maxRetentionPercent" class="input oc-input" type="number" />
                    </p>
                </div>
            </div>
        </div>

        <!-- Galaxsys -->
        <p class="title is-4 is-spaced">Galaxsys</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.galaxsysSettings.widgetUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Operator id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.galaxsysSettings.operatorId" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Private key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.galaxsysSettings.privateKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- SmartSoft -->
        <p class="title is-4 is-spaced">SmartSoft</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smartSoftSettings.widgetUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Private key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smartSoftSettings.privateKey" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Games sync url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smartSoftSettings.gamesSyncUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- Boldplay -->
        <p class="title is-4 is-spaced">Boldplay</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.boldplaySettings.widgetUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Boldplay API secret</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.boldplaySettings.apiSecret" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Games sync url</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.boldplaySettings.gamesSyncUrl" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Platform id</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.boldplaySettings.platformId" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>        

        <!-- Smtp -->
        <p class="title is-4 is-spaced">Smtp</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.smtpSettings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smtpSettings.host" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Port</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smtpSettings.port" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enable Ssl</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.smtpSettings.enableSsl" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">UserName</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smtpSettings.userName" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">UserPassword</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.smtpSettings.userPassword" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!--StatsSending-->
        <p class="title is-4 is-spaced">Stats sending</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Enabled</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.statsSendingSettings.enabled" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Email</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.statsSendingSettings.email" class="input oc-input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Clients</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select is-multiple oc-input">
                            <select v-model="settings.statsSendingSettings.clientIds" multiple size="10">
                                <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.name }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Methods</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select is-multiple">
                            <select v-model="settings.statsSendingSettings.methods" multiple size="5">
                                <option value="Explicit">Explicit</option>
                                <option value="Pin">Pin</option>
                                <option value="Cashback">Cashback</option>
                                <option value="PaymentSystem">PaymentSystem</option>
                                <option value="Bonus">Bonus</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Toto -->
        <p class="title is-4 is-spaced">Toto</p>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.totoSettings.apiHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">API key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.totoSettings.apiKey" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Widget host</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="settings.totoSettings.widgetHost" class="input" type="text" />
                    </p>
                </div>
            </div>
        </div>

        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import systemSettingsService from '../../services/systemsettings.service';
import state from "../../state";
import CurrencyInput from '../common/currency-input.vue';

export default {
    name: 'system-settings',
    components: { CurrencyInput },
    data() {
        return {
            settings: {
                flgSettings: {},
                bkSettings: {},
                covidSettings: {},
                bonusSettings: { registrationBonusMaxValue: [] },
                jackpotSettings: {},
                mbkSettings: {},
                withdrawalSettings: {},
                galaxsysSettings: {},
                smartSoftSettings: {},
                boldplaySettings: {},
                doubleChanceLottoSettings: {},
                smtpSettings: {},
                statsSendingSettings: {email: '', clientIds: [], methods: []},
                totoSettings: {},
            }
        };
    },
    computed: {
        clients () {
            return state.clients.get();
        },
    },
    async mounted() {
        this.settings = await systemSettingsService.get();
    },
    methods: {
        async save() {
            console.log(this.settings.statsSendingSettings)
            this.settings = await systemSettingsService.save(this.settings);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/system/system-settings.vue